import "./index.scss";

import React from "react";
import { useTranslation } from "react-i18next";

import Button from "@/components/components/Button";
import { SimpleDropdown } from "@/components/components/Dropdown";
import { TDropdownOption } from "@/components/components/Dropdown/dropdown.type";
import { Close } from "@/components/icons";


interface AttributesProps {
    title: string;
    multiple?: boolean;
    mode?: string;
    error?: string;
    options: TDropdownOption<string>[];
    selectedOption?: TDropdownOption<string>;
    selectedOptions?: Array<TDropdownOption>;
    onSelect: (tz: TDropdownOption) => void;
    onClick: () => void;
    onClose?: () => void;
}

const Attributes: React.FunctionComponent<AttributesProps> = (
    props: AttributesProps,
) => {

    const { t } = useTranslation();

    const optionClassNames = {
        optionHeading: "c-setting__dropdown-option-heading",
    };

    return (
        <div className={(props.mode ==="first") ?"c-first-login":"c-setting"} role="application" aria-label="Setting">
            {props.onClose && <button className="c-setting__close-button" onClick={() => props.onClose()}>
                <Close width={14} height={14} />
            </button>}
            <label className="c-setting__subheading">{props.title === "Branch(es)" ? t("Let's update your workspace.") : t("What is your time zone?")} </label>
            <SimpleDropdown
                multiple={props.multiple && props.multiple}
                className="c-setting__dropdown"
                dropdownDefaultRenderClassNames={{header: "c-setting__dropdown-header"}}
                heading={t(`Select ${props.title}`)}
                onSelect={props.onSelect}
                optionClassNames={optionClassNames}
                options={props.options}
                optionsContainerClassNames={{ menu: "c-setting__dropdown-options" }}
                search={true}
                selectedOption={props.selectedOption}
                selectedOptions={props.multiple && props.selectedOptions}
            />
            <Button disabled={!props.options || props.selectedOptions?.length < 1} className="c-setting__button" onClick={props.onClick} ariaLabel={"First Login Continue Button"}>
                {t("Continue")}
            </Button>
        </div>
    );
};

export default Attributes;
